import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { HOW_TO_REDEEM } from '../../config/text/text';
import { getRedeemImageSource } from '../../helpers/image';
import ThemeContext from '../../providers/ThemeProvider';
import SectionTitle from './shared-components/SectionTitle';

const MainDealRedeem = ({ className, deal = {}, details = {} }) => {
  const theme = useContext(ThemeContext);
  const [collapsed, setCollapsed] = useState(true);

  const source = getRedeemImageSource(deal, details);

  return (
    <>
      <div className={classNames('redeem', className)}>
        <div className="hide-desktop">
          <SectionTitle
            collapsed={collapsed}
            onToggleCollapse={() => setCollapsed((state) => !state)}
            title={HOW_TO_REDEEM}
          />
        </div>
        <div
          className={classNames('redeem__image', {
            'redeem__image--show': !collapsed,
          })}
        >
          <img
            alt="How to redeem"
            className="img-fluid"
            height="170"
            loading="lazy"
            src={source}
            width="505"
          />
        </div>
      </div>
      <style jsx>
        {`
          .redeem {
            width: 100%;
          }
          .redeem__image {
            padding: 20px 10px;
            border: 3px solid ${theme.colors.primary};
            margin-bottom: 20px;
            width: 100%;
          }
          .redeem__image .img-fluid {
            width: 100%;
          }
          .hide-desktop {
            display: none;
          }
          @media (max-width: ${theme.breakpoints.mdDown}) {
            .redeem__image {
              display: none;
            }
            .redeem__image--show {
              display: block;
            }
            .hide-desktop {
              display: block;
            }
          }
        `}
      </style>
    </>
  );
};

MainDealRedeem.propTypes = {
  className: PropTypes.string,
  deal: PropTypes.object,
  details: PropTypes.object,
};

export default MainDealRedeem;
